import { render, staticRenderFns } from "./EProposalSms.vue?vue&type=template&id=ff2e866c&"
import script from "./EProposalSms.vue?vue&type=script&lang=js&"
export * from "./EProposalSms.vue?vue&type=script&lang=js&"
import style0 from "./EProposalSms.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports